/**
* Very simple i18n wrapper for now
*/

import IntlMessageFormat from 'intl-messageformat';
import createFormatCache from 'intl-format-cache';

import config from '../config';

let dictionary = require('../messages/dictionary').default;

if (module.hot) {
    module.hot.accept('../messages/dictionary', function () {
        dictionary = require('../messages/dictionary').default;
    });
}

const getMessageFormat = createFormatCache(IntlMessageFormat);


/**
 * Recursively resolve a key in the dictionary
 */
export function getFinalMessage (dict, key, count = 0) {
    if (count > 5) {
        throw new Error(`Mutually referencing dictionary key: ${key}`);
    }
    const message = dict.get(key);
    return !message ? key : getFinalMessage(dict, message, ++count);
}

/**
 * Returns {true} if dictionary contains message for `key`
 */
export function hasMessage (key) {
    return dictionary[config.get('brand')].has(key);
}

/**
 * Replace <{variable}> with a value from the dictionary
 */
export function replaceGlobals (dict, input) {
    const regExp = /<\{(.*?)\}>/g;
    let output = input;
    let match;

    while ((match = regExp.exec(input)) !== null) {
        const key = match[1];
        const value = dict.get(key);

        if (!value) { console.warn(`Couldn't find global value: ${key}`); }

        output = output.replace(match[0], value);
    }

    return output;
}

/**
 * Translate a key to a message
 */
export function translate (key, values, fallback = null) {
    if (!key) { console.warn('Translate called with no key'); }
    const dict = dictionary[config.get('brand')];

    let message = getFinalMessage(dict, key);

    if (message === key) { message = fallback || key; }

    return message ? getMessageFormat(replaceGlobals(dict, message)).format(values) : null;
}

export default translate;



// WEBPACK FOOTER //
// ./src/lib/I18n.js